export default "/img/AE.1b994f158690ae17ae8e373690231f13.png";